import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=f3e647d8&scoped=true"
var script = {}
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=f3e647d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e647d8",
  null
  
)

export default component.exports